/**
 * Los avisos de espera del agente.
 *
 * Cuando el agente preve que va a tardar -dos o mas consultas al CRM, o una
 * escritura- manda antes una frase corta: «voy a repasar tu cartera». Ese
 * mensaje se guarda como del bot pero NO es la respuesta, y en la bandeja se
 * pinta atenuado para que no compita con ella al releer la conversacion.
 *
 * Vive aparte del componente para poder probarlo sin montar la vista entera.
 */
export function isInterimMessage(metadata: Record<string, unknown> | undefined): boolean {
  return metadata?.interim === true
}
